import React from "react";
import ManufactureAllTabs from "../manufacturing/ManufactureAllTabs";

export default function ManufacturingTable({
  openModalToCreateJobClusters,
  setOpenModalToCreateJobClusters,
  openModalToPublishJobClusters,
  setOpenModalToPublishJobClusters,
  openModalToCreateClustersForPrinting,
  setOpenModalToCreateClustersForPrinting,
  campaignData,
  service,
}) {
  return (
    <div>
      <ManufactureAllTabs
        campaignData={campaignData}
        openModalToCreateJobClusters={openModalToCreateJobClusters}
        setOpenModalToCreateJobClusters={setOpenModalToCreateJobClusters}
        setOpenModalToPublishJobClusters={setOpenModalToPublishJobClusters}
        openModalToPublishJobClusters={openModalToPublishJobClusters}
        openModalToCreateClustersForPrinting={
          openModalToCreateClustersForPrinting
        }
        setOpenModalToCreateClustersForPrinting={
          setOpenModalToCreateClustersForPrinting
        }
        service={service}
      />
    </div>
  );
}
